/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem
 */
export interface WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem {
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem
     */
    merchantId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem
     */
    vat?: number;
}

/**
 * Check if a given object implements the WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem interface.
 */
export function instanceOfWebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemFromJSON(json: any): WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem {
    return WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemFromJSONTyped(json, false);
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'merchantId': !exists(json, 'merchant_id') ? undefined : json['merchant_id'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'vat': !exists(json, 'vat') ? undefined : json['vat'],
    };
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemToJSON(value?: WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'merchant_id': value.merchantId,
        'price': value.price,
        'quantity': value.quantity,
        'vat': value.vat,
    };
}

